import type { ICoreDataWrapper } from '@eureka/services/src/exception';
import type { IProject, IExportParams, ISaveCompanyParams, CatalogItem } from '@/types';
import { container } from '@eureka/services';

export function getProjectInfo(projectId: string) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/${projectId}`
    return container.RnDHttp.get<ICoreDataWrapper<IProject>>({
        url,
    }).then(res => {
        return res.data
    });
}

export function refreshReportInfo(projectId: string) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/refresh/${projectId}`
    return container.RnDHttp.put<ICoreDataWrapper<IProject>>({
        url,
    }).then(res => {
        return res.data
    });
}

export function exportReport(params: IExportParams) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/export`
    return container.RnDHttp.post<ICoreDataWrapper<string>>({
        url,
        data: params,
    }).then(res => {
        return res.data
    });
}

export function saveCompany(data: ISaveCompanyParams) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/add_header_player`
    return container.RnDHttp.post<ICoreDataWrapper<string>>({
        url,
        data,
    }).then(res => {
        return res.data
    });
}

export function getReportDirectory(projectId: string) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/directory/${projectId}`
    return container.RnDHttp.get<ICoreDataWrapper<CatalogItem[]>>({
        url,
    }).then(res => {
        return res.data
    });
}
